import { render, staticRenderFns } from "./QuadrupleBanner.vue?vue&type=template&id=2012f6cc&scoped=true"
import script from "./QuadrupleBanner.vue?vue&type=script&lang=js"
export * from "./QuadrupleBanner.vue?vue&type=script&lang=js"
import style0 from "./QuadrupleBanner.vue?vue&type=style&index=0&id=2012f6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012f6cc",
  null
  
)

export default component.exports